export default __webpack_public_path__ + "static/media/CloudDarkIcon.894b25d5.svg";